import { Component, Input, OnInit } from '@angular/core';
import { NgbActiveModal } from '@ng-bootstrap/ng-bootstrap';
import { EmployeeService } from '../../../../pages/employee/services/employee.service';

@Component({
  selector: 'app-view-detail-modal',
  templateUrl: './view-detail-modal.component.html',
  styleUrls: ['./view-detail-modal.component.css']
})
export class ViewDetailModalComponent implements OnInit {

  @Input() hideGrade: boolean = false;
  @Input() data: any;
  savedFiles: any[] = [];

  constructor(private employeeservice: EmployeeService, private activeModal: NgbActiveModal) { }

  ngOnInit(): void {
    this.getAttachment();
  }

  getAttachment() {
    this.employeeservice.trainingAttachmentsGetList(this.data.ItemKeyID, this.data.SkillOrTraining).then((response: any[]) => {
      this.savedFiles = response;
    });
  }

  closeClicked() {
    this.activeModal.close();
  }

}
